import { TFN_DECLARATION } from '@/core/field-names';

/**
 * Filtering fields that will only contribute to tfnDeclaration
 * document completion.
 * @param fieldValueMap {Object}
 * @param fieldValueMap.value {Any}
 * @param fieldValueMap.required {Boolean}
 * @param fieldValueMap.errorList {String[]}
 * @returns {String[]}
 */
export function filterTFNFieldsToBeIncluded(fieldValueMap) {
  const hasTFN = fieldValueMap[TFN_DECLARATION.OPTION]?.value === 'Yes';
  const hasNoTFN = fieldValueMap[TFN_DECLARATION.OPTION]?.value === 'No';

  const isWorkingHolidayMaker =
    fieldValueMap[TFN_DECLARATION.RESIDENT_STATUS]?.value === 'working-holiday';

  const tfnRule = {
    [TFN_DECLARATION.OPTION]: true,
    [TFN_DECLARATION.TFN]: hasTFN,
    [TFN_DECLARATION.REASON]: hasNoTFN,
    [TFN_DECLARATION.TITLE]: true,
    [TFN_DECLARATION.NAME]: true,
    [TFN_DECLARATION.PAY_BASIS]: true,
    [TFN_DECLARATION.RESIDENT_STATUS]: true,
    [TFN_DECLARATION.COUNTRY_OF_ORIGIN]: isWorkingHolidayMaker,
    [TFN_DECLARATION.TAX_FREE_THRESHOLD]: true,
    [TFN_DECLARATION.HELP_LOAN_OR_STUDENT_DEBT]: true,
    [TFN_DECLARATION.DECLARATION]: true,
  };

  return Object.keys(tfnRule).filter((key) => {
    return fieldValueMap[key]?.required && tfnRule[key];
  });
}

export function filterTFNFieldsToBeIncludedWhenNoOptionExists(fieldValueMap) {
  const hasTFN = fieldValueMap[TFN_DECLARATION.OPTION]?.value === undefined;

  const tfnRuleWithNoOption = {
    [TFN_DECLARATION.TFN]: hasTFN,
  };

  return Object.keys(tfnRuleWithNoOption).filter((key) => {
    return tfnRuleWithNoOption[key];
  });
}
